import { render, staticRenderFns } from "./help-feedback.vue?vue&type=template&id=79707c44&scoped=true&"
import script from "./help-feedback.vue?vue&type=script&lang=js&"
export * from "./help-feedback.vue?vue&type=script&lang=js&"
import style0 from "./help-feedback.vue?vue&type=style&index=0&id=79707c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79707c44",
  null
  
)

export default component.exports